import { zodResolver } from "@hookform/resolvers/zod";
import { useRecordContext } from "react-admin";

import { fmtDateTimeDE, joinAddressLine } from "../components/raFormat";
import {
  AppEdit,
  AppFormContent,
  AppFormSection,
  AppSimpleForm,
  RecordMetaCard,
  SectionHeader,
  AppTextInput,
  AppReferenceInput,
  AppFormToolbar,
} from "../../layout";
import {
  clientEditFormSchema,
} from "../schemas";
import { toUpdateClientCommand } from "../mappers";

export function ClientMeta() {
  const r = useRecordContext<any>();
  if (!r) return null;

  return (
    <RecordMetaCard
      title="Systemdaten"
      rows={[
        { label: "Erstellt", value: fmtDateTimeDE(r.createdAt) },
        { label: "Aktualisiert", value: fmtDateTimeDE(r.updatedAt) },
        { label: "Version", value: r.version ?? "—" },
      ]}
    />
  );
}

function ClientEditFields() {
  return (
    <>
      <AppTextInput source="name" label="Name" required fullWidth />
      <AppTextInput source="contactName" label="Ansprechpartner" fullWidth />
      <AppTextInput source="phone" label="Telefon" fullWidth />
      <AppTextInput source="email" label="E-Mail" type="email" fullWidth />

      <AppReferenceInput
        source="addressId"
        reference="addresses"
        label="Adresse"
        autocompleteProps={{
          optionText: (record: any) => joinAddressLine(record),
          fullWidth: true,
        }}
      />
    </>
  );
}

export const ClientEdit = () => (
  <AppEdit
    mutationMode="pessimistic"
    aside={<ClientMeta />}
    transform={toUpdateClientCommand}
  >
    <AppSimpleForm
      resolver={zodResolver(clientEditFormSchema) as any}
      mode="onBlur"
      toolbar={<AppFormToolbar />}
    >
      <AppFormSection>
        <SectionHeader title="Stammdaten" subtitle="Grunddaten des Kunden." />

        <AppFormContent>
          <ClientEditFields />
        </AppFormContent>
      </AppFormSection>
    </AppSimpleForm>
  </AppEdit>
);
